import { AdminReservationList } from '../model/adminReservation-list';
import { AdminReservationPremium } from '../model/adminReservationPremium';
import { AdminReservationBuilder } from './adminReservation-builder';
import * as _ from 'lodash-es';
export class AdminReservationPremiumBuilder extends AdminReservationBuilder {
    static buildAdminReservationPremium(data) {
        let adminReservationPremium = new AdminReservationPremium();
        let adminReservation = this.buildAdminReservation(data);
        adminReservationPremium.time_distance = data.time_distance;
        adminReservationPremium.client_lat = data.client_lat;
        adminReservationPremium.client_lng = data.client_lng;
        adminReservationPremium.client_prediction_distance = data.client_prediction_distance;
        adminReservationPremium.client_prediction_duration = data.client_prediction_duration;
        adminReservationPremium.client_prediction_status = data.client_prediction_status;
        adminReservationPremium.client_waiting = data.client_waiting;
        adminReservationPremium.client_timestamp = data.client_timestamp;
        adminReservationPremium.client_geofence = data.client_geofence;
        adminReservationPremium.client_geofence_in_timestamp = data.client_geofence_in_timestamp;
        adminReservationPremium.user_agent_status = data.user_agent_status;
        adminReservationPremium.user_status_timestamp = data.user_status_timestamp;
        adminReservationPremium.user_position_timestamp = data.user_position_timestamp;
        adminReservationPremium.user_lat = data.user_lat;
        adminReservationPremium.user_lng = data.user_lng;
        adminReservationPremium.user_waiting = data.user_waiting;
        adminReservationPremium.user_prediction_distance = data.user_prediction_distance;
        adminReservationPremium.user_prediction_duration = data.user_prediction_duration;
        adminReservationPremium.user_geofence = data.user_geofence;
        adminReservationPremium.user_geofence_in_timestamp = data.user_geofence_in_timestamp;
        adminReservationPremium.user_multireception = data.user_multireception;
        adminReservationPremium.user_multireception_terminal = data.user_multireception_terminal;
        adminReservationPremium.user_timestamp = data.user_timestamp;
        adminReservationPremium.user_alias = data.user_alias;
        adminReservationPremium.internal_premium_warning_level = data.internal_premium_warning_level;
        adminReservationPremium.queued = data.queued;
        adminReservationPremium.wash_status = data.wash_status;
        adminReservationPremium.fs_publishedArrival = data.fs_publishedArrival ? new Date(data.fs_publishedArrival) : null;
        const adminReservationFull = Object.assign(Object.assign({}, adminReservation), adminReservationPremium);
        return adminReservationFull;
    }
    static buildAdminReservationPremiumList(data) {
        const adminReservationPremiumList = new AdminReservationList();
        adminReservationPremiumList.page = data.page;
        adminReservationPremiumList.pagination = data.pagination;
        adminReservationPremiumList.total = data.total;
        adminReservationPremiumList.totalPages = data.totalPages;
        adminReservationPremiumList.reservations = _.map(data.reservations, (adminReservation) => {
            return AdminReservationPremiumBuilder.buildAdminReservationPremium(adminReservation);
        });
        return adminReservationPremiumList;
    }
}
//# sourceMappingURL=adminReservationPremium-builder.js.map